module.exports = __webpack_public_path__ + "img/nav-header-mobile-wedding@2x.1a08188.jpg";